import { css } from '@emotion/react'
import common from 'shared/styles'

const styles = () => {
    return {
        text: css`
            padding-left: 30px;
            height: 100%;
            width: 100%;
        `,
        buttons: css`
            ${common.flexJustityAlignCenter};
            padding-top: 30px;
        `,
        button: common.stepsPictureButton,
    }
}

export default styles
